import type { DayPartV5 } from '../../../../apis/graphql';

export const filterDaysList = (dayPartList: DayPartV5[]): DayPartV5[] => {
  return dayPartList.filter((darkDay): boolean => {
    if (darkDay.firstActiveHour === null || darkDay.lastActiveHour === null) return false;

    return darkDay.activeDayList.length > 0 && darkDay.firstActiveHour <= darkDay.lastActiveHour;
  });
};
